import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Name the Hold",
    opening: localizedGenderNode(
      [
      "Today I name it.",
      "This is one-sided love that I struggle to release.",
      "I am here."
    ],
      [
      "Today I name it.",
      "This is one-sided love that I struggle to release.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When is this hold especially strong?",
      "What do I tell myself in those moments?",
      "Where do I feel this in my body?"
    ],
      [
      "When is this hold especially strong?",
      "What do I tell myself in those moments?",
      "Where do I feel this in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "The feeling is strong, but it is not my definition."
    ],
      [
      "The feeling is strong, but it is not my definition."
    ]
    ),
    action: localizedGenderNode(
      "one breath + \"I am with myself in this\".",
      "one breath + \"I am with myself in this\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Fact vs. Fantasy",
    opening: localizedGenderNode(
      [
      "Today I separate what happens from what I imagine.",
      "Without fighting it.",
      "I stay with myself."
    ],
      [
      "Today I separate what happens from what I imagine.",
      "Without fighting it.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe in and out.",
      "One breath."
    ],
      [
      "I breathe in and out.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What simple facts do I have?",
      "What do I add in my imagination?",
      "What hurts when I face the fact?"
    ],
      [
      "What simple facts do I have?",
      "What do I add in my imagination?",
      "What hurts when I face the fact?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A fact does not cancel the feeling."
    ],
      [
      "A fact does not cancel the feeling."
    ]
    ),
    action: localizedGenderNode(
      "write one fact only.",
      "write one fact only."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "What I Am Seeking",
    opening: localizedGenderNode(
      [
      "Today I look at what I seek in this love.",
      "Without shrinking it.",
      "I am here."
    ],
      [
      "Today I look at what I seek in this love.",
      "Without shrinking it.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my chest.",
      "One breath."
    ],
      [
      "I notice my chest.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What feeling do I want to receive there?",
      "What do I want to feel about myself?",
      "What am I afraid to lose?"
    ],
      [
      "What feeling do I want to receive there?",
      "What do I want to feel about myself?",
      "What am I afraid to lose?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "My need is real, even if the direction hurts."
    ],
      [
      "My need is real, even if the direction hurts."
    ]
    ),
    action: localizedGenderNode(
      "one short need sentence.",
      "one short need sentence."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "The Inner Loop",
    opening: localizedGenderNode(
      [
      "Today I recognize the loop of longing.",
      "Just noticing it.",
      "I stay with myself."
    ],
      [
      "Today I recognize the loop of longing.",
      "Just noticing it.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my sitting.",
      "One breath."
    ],
      [
      "I feel my sitting.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How does this loop usually begin?",
      "What keeps it alive?",
      "Where can I pause for a small moment?"
    ],
      [
      "How does this loop usually begin?",
      "What keeps it alive?",
      "Where can I pause for a small moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A loop can include a small pause."
    ],
      [
      "A loop can include a small pause."
    ]
    ),
    action: localizedGenderNode(
      "one 10-second pause.",
      "one 10-second pause."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "An Inner Boundary",
    opening: localizedGenderNode(
      [
      "Today I check where I cross a boundary with myself.",
      "Without blame.",
      "I am here."
    ],
      [
      "Today I check where I cross a boundary with myself.",
      "Without blame.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I place a hand on my chest.",
      "One breath."
    ],
      [
      "I place a hand on my chest.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I do that deepens the pain?",
      "What small boundary is possible for me today?",
      "What am I afraid of if I set it?"
    ],
      [
      "What do I do that deepens the pain?",
      "What small boundary is possible for me today?",
      "What am I afraid of if I set it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small boundary is a gentle protection."
    ],
      [
      "A small boundary is a gentle protection."
    ]
    ),
    action: localizedGenderNode(
      "one inner boundary sentence.",
      "one inner boundary sentence."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Triggers",
    opening: localizedGenderNode(
      [
      "Today I notice what triggers me around this love.",
      "Just noticing.",
      "I stay with myself."
    ],
      [
      "Today I notice what triggers me around this love.",
      "Just noticing.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my breath.",
      "One breath."
    ],
      [
      "I notice my breath.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What triggers me most? (place/song/time)",
      "What feeling rises immediately?",
      "What do I need in that moment?"
    ],
      [
      "What triggers me most? (place/song/time)",
      "What feeling rises immediately?",
      "What do I need in that moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "When I notice a trigger I am not alone in it."
    ],
      [
      "When I notice a trigger I am not alone in it."
    ]
    ),
    action: localizedGenderNode(
      "a hand on my chest when it rises.",
      "a hand on my chest when it rises."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "The Part That Hopes",
    opening: localizedGenderNode(
      [
      "Today I make space for the part that hopes.",
      "Without dismissing it.",
      "I am here."
    ],
      [
      "Today I make space for the part that hopes.",
      "Without dismissing it.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I soften my shoulders.",
      "One breath."
    ],
      [
      "I soften my shoulders.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is beautiful about my hope?",
      "What is hard about this hope?",
      "What do I want to protect?"
    ],
      [
      "What is beautiful about my hope?",
      "What is hard about this hope?",
      "What do I want to protect?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "My hope deserves gentleness."
    ],
      [
      "My hope deserves gentleness."
    ]
    ),
    action: localizedGenderNode(
      "one gentle sentence to hope.",
      "one gentle sentence to hope."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "The Part That Grieves",
    opening: localizedGenderNode(
      [
      "Today I allow the grief to be here.",
      "Not to sink into it.",
      "I stay with myself."
    ],
      [
      "Today I allow the grief to be here.",
      "Not to sink into it.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my eyes and breath.",
      "One breath."
    ],
      [
      "I notice my eyes and breath.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I grieving here?",
      "What did I want to give?",
      "What did I want to receive?"
    ],
      [
      "What am I grieving here?",
      "What did I want to give?",
      "What did I want to receive?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Grief is love with no place to go."
    ],
      [
      "Grief is love with no place to go."
    ]
    ),
    action: localizedGenderNode(
      "one breath with the grief.",
      "one breath with the grief."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "How It Touches My Worth",
    opening: localizedGenderNode(
      [
      "Today I check how this touches my worth.",
      "Not to judge.",
      "I am here."
    ],
      [
      "Today I check how this touches my worth.",
      "Not to judge.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I soften my jaw.",
      "One breath."
    ],
      [
      "I soften my jaw.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I tell myself about me in this?",
      "What would I say to a friend here?",
      "What do I want to believe about me?"
    ],
      [
      "What do I tell myself about me in this?",
      "What would I say to a friend here?",
      "What do I want to believe about me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "My worth does not depend on an outside response."
    ],
      [
      "My worth does not depend on an outside response."
    ]
    ),
    action: localizedGenderNode(
      "one worth sentence to myself.",
      "one worth sentence to myself."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "A Request to Myself",
    opening: localizedGenderNode(
      [
      "Today I give myself one clear request.",
      "Not a demand.",
      "I stay with myself."
    ],
      [
      "Today I give myself one clear request.",
      "Not a demand.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my belly soften a little.",
      "One breath."
    ],
      [
      "I feel my belly soften a little.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is my most important request right now?",
      "How do I say it in one sentence?",
      "What am I willing to give myself in return?"
    ],
      [
      "What is my most important request right now?",
      "How do I say it in one sentence?",
      "What am I willing to give myself in return?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One request is a small anchor."
    ],
      [
      "One request is a small anchor."
    ]
    ),
    action: localizedGenderNode(
      "write the request in a short sentence.",
      "write the request in a short sentence."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "A Small Shift",
    opening: localizedGenderNode(
      [
      "Today I choose a small shift within the day.",
      "Not a revolution.",
      "I am here."
    ],
      [
      "Today I choose a small shift within the day.",
      "Not a revolution.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice one point of contact in my body.",
      "One breath."
    ],
      [
      "I notice one point of contact in my body.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small shift am I willing to try today?",
      "When is it easiest to try it?",
      "What will gently remind me to choose it?"
    ],
      [
      "What small shift am I willing to try today?",
      "When is it easiest to try it?",
      "What will gently remind me to choose it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small shift is a gentle movement."
    ],
      [
      "A small shift is a gentle movement."
    ]
    ),
    action: localizedGenderNode(
      "choose one moment to try it.",
      "choose one moment to try it."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Staying With Myself",
    opening: localizedGenderNode(
      [
      "Today I notice the moment I stay with myself.",
      "Instead of chasing.",
      "I am here."
    ],
      [
      "Today I notice the moment I stay with myself.",
      "Instead of chasing.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I hear my breath.",
      "One breath."
    ],
      [
      "I hear my breath.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When do I tend to chase in my mind?",
      "What does a moment of staying with myself look like?",
      "How do I feel after it?"
    ],
      [
      "When do I tend to chase in my mind?",
      "What does a moment of staying with myself look like?",
      "How do I feel after it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Staying with myself is a choice."
    ],
      [
      "Staying with myself is a choice."
    ]
    ),
    action: localizedGenderNode(
      "say in my heart \"I am with myself\" once.",
      "say in my heart \"I am with myself\" once."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A Small New Direction",
    opening: localizedGenderNode(
      [
      "Today I make room for a small new direction.",
      "Not far, just possible.",
      "I am here."
    ],
      [
      "Today I make room for a small new direction.",
      "Not far, just possible.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my back supported.",
      "One breath."
    ],
      [
      "I feel my back supported.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I want to feel more in life?",
      "What small value do I want to live today?",
      "What is a small sign that it is happening?"
    ],
      [
      "What do I want to feel more in life?",
      "What small value do I want to live today?",
      "What is a small sign that it is happening?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small direction can be enough for today."
    ],
      [
      "A small direction can be enough for today."
    ]
    ),
    action: localizedGenderNode(
      "one short value sentence.",
      "one short value sentence."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle Closure",
    opening: localizedGenderNode(
      [
      "Today I close the journey gently.",
      "Without forcing a perfect ending.",
      "I am here."
    ],
      [
      "Today I close the journey gently.",
      "Without forcing a perfect ending.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about this love?",
      "What is the early sign I am entering the loop again?",
      "Return sentence for the moment before - what do I say to myself?"
    ],
      [
      "What did I learn about this love?",
      "What is the early sign I am entering the loop again?",
      "Return sentence for the moment before - what do I say to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can love and still stay with myself."
    ],
      [
      "I can love and still stay with myself."
    ]
    ),
    action: localizedGenderNode(
      "one breath before responding.",
      "one breath before responding."
    ),
  },
].map(buildNormalizedDay);

export const gettingStuckOnAnImpossibleOneSidedLoveBlueprintEn = buildNormalizedPilotBlueprint({
  id: "getting_stuck_on_an_impossible_one_sided_love_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "getting_stuck_on_an_impossible_one_sided_love",
  category: "love_and_relationships",
  journeyName: {
    he: "אהבה בלתי אפשרית / חד-צדדית",
    en: "Getting stuck in an impossible one-sided love",
    es: "Quedarme atrapado/a en un amor imposible y unilateral",
  },
  days,
});

export default gettingStuckOnAnImpossibleOneSidedLoveBlueprintEn;
